import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { Link } from "react-router-dom";
import { DataTable } from "../../../components";
import Tick from "../../../icons/tick.svg";
import Cross from "../../../icons/cross.svg";
import Pending from "../../../icons/pending.svg";
import { getAlertas, getAllSuppDocs, getConsultores } from "../../../services";
import {
  daysDiff,
  formatoFechasEs,
} from "../../../functions/funciones";
import {
  Box,
  Tooltip,
  Button
} from "@mui/material";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { UsuarioContext } from "../../../providers/userContext";
import { useLocation,useNavigate } from "react-router-dom";
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';

const Alertas = () => {
  const { t } = useTranslation(['suppliers', 'common']);

  const urlPadre = window.location.pathname;
  const navigate = useNavigate();
  const user = useContext(UsuarioContext)
  const [Consultores, setConsultores] = useState([]);
  const {filtroOrder} = useRecogerURLParamsFiltros();
  
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });
  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem("hasReloaded") === "true") {

      fetchData();
      localStorage.setItem("hasReloaded", "false"); 
    }
  }, [location]);

  useEffect(() => {
    // fetchData();
    getConsultores().then((res) => {
      setConsultores(res);
    });
  }, [recargar]);

  useEffect(() => {
    if (localStorage.getItem("hasReloaded") === "true") {

      fetchData();
      localStorage.setItem("hasReloaded", "false"); 
    }
  }, [location]);

  const fetchData = async ({ offset, limit, filtros = {},order,orderBy } = {}) => {
    
    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order =   order || filtroOrder.orden || 'ASC';

    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros,order, orderBy);

    const payload = {
      // filtros:{ultimaReclamacion:new Date().setDate(new Date().getDate() - 60)},
      filtros: {tech_id: user.id},
      params: { page: offset, limit,order, orderBy },
    };

    try {
      setLoading(true);
      
      const response1 = await getAllSuppDocs(payload);
      const { meta, data} = response1;
     
      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatData = (data) => {
    return data.map((row, i) => ({
      
      
      proveedor_id: row.id,
      razonSocial: row.razonSocial,
      esCreatedAt: !row.ultimaReclamacion,
      ultimaReclamacion: row.ultimaReclamacion || row.createdAt,
      // ultimaReclamacion: row.ultimaReclamacion || row.createdAt,
      nif: row.nif,
      documentosTrabajadores: row.docTrabajadores,
      planificacionPreventiva: row.docssupps?.find((d) => d.tipoDoc === 4)?.fechaCaducidad || '',
      planificacionPreventivaUR: row.docssupps?.find((d) => d.tipoDoc === 4)?.ultimaReclamacion || '',
      evaluacionRiesgos: row.docssupps?.find((d) => d.tipoDoc === 5)?.validado || '',
      evaluacionRiesgosUR: row.docssupps?.find((d) => d.tipoDoc === 5)?.ultimaReclamacion || '',
      // vigilancia: row.docssupps?.find((d) => d.tipoDoc === 7)?.fechaCaducidad || '',
      // vigilanciaUR: row.docssupps?.find((d) => d.tipoDoc === 7)?.ultimaReclamacion || '',
      rlc: row.docssupps?.find((d) => d.tipoDoc === 9)?.fechaCaducidad || '',
      rlcUR: row.docssupps?.find((d) => d.tipoDoc === 9)?.ultimaReclamacion || '',
      rnt: row.docssupps?.find((d) => d.tipoDoc === 8)?.fechaCaducidad || '',
      rntUR: row.docssupps?.find((d) => d.tipoDoc === 8)?.ultimaReclamacion || '',
      listadoTrabajadores: row.docssupps?.find((d) => d.tipoDoc === 10)?.fechaCaducidad || '',
      listadoTrabajadoresUR: row.docssupps?.find((d) => d.tipoDoc === 10)?.ultimaReclamacion || '',
      certificado: row.docssupps?.find((d) => d.tipoDoc === 6)?.fechaCaducidad || '',
      certificadoUR: row.docssupps?.find((d) => d.tipoDoc === 6)?.ultimaReclamacion || '',
      justificante: row.docssupps?.find((d) => d.tipoDoc === 3)?.fechaCaducidad || '',
      justificanteUR: row.docssupps?.find((d) => d.tipoDoc === 3)?.ultimaReclamacion || '',
      seguro: row.docssupps?.find((d) => d.tipoDoc === 2)?.fechaCaducidad || '',
      seguroUR: row.docssupps?.find((d) => d.tipoDoc === 2)?.ultimaReclamacion || '',
      validar: row.id,
      noProcede: row.noProcede
    }));
  };

  const proveedoresRows = [

    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.supplier'),
      overrideFunc: (data, row) => <Link to={"/proveedores/" + row.nif}>{data}</Link>
    },
    {
      id: "ultimaReclamacion",
      numeric: false,
      disablePadding: false,
      label: t('columns.lastReclamation'),
      // overrideFunc: (data, row) => <span>{isNaN ? formatoFechasEs(data) : "-"}</span>
      
      overrideFunc: (data, row) => <span style={{color: daysDiff(new Date(data), new Date()) > 30 ? 'red' : 'black'}}>{formatoFechasEs(data)}</span>
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('columns.nif'),
    },
    {
      id: "seguro",
      numeric: false,
      disablePadding: false,
      label: t('documentTypes.rc'),
      noObjeto: true,
      style: { whiteSpace: 'nowrap', textAlign: 'center' },
      overrideFunc: (data, row) => (
        data ?
          <Tooltip title={row.seguroUR === '' ? t('common:suppliers.messages.lastClaim') + ': -' : t('common:suppliers.messages.lastClaim') + ": " + formatoFechasEs(row.seguroUR)}>
            <span style={{ color: daysDiff(new Date(row?.seguroUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
              {formatoFechasEs(data)}
            </span>
          </Tooltip> : '-'
      )
    },
    {
      id: "justificante",
      numeric: false,
      disablePadding: false,
      label: t('documentTypes.preventiveModality'),
      noObjeto: true,
      style: { whiteSpace: 'nowrap', textAlign: 'center' },
      overrideFunc: (data, row) => (
        row.noProcede ? t('common:suppliers.columns.notApplicable') :
          data ?
            <Tooltip title={row.justificanteUR === '' ? t('common:suppliers.messages.lastClaim') + ': -' : t('common:suppliers.messages.lastClaim') + ": " + formatoFechasEs(row.justificanteUR)}>
              <span style={{ color: daysDiff(new Date(row?.justificanteUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
                {formatoFechasEs(data)}
              </span>
            </Tooltip> : '-'
      )
    },
    {
      id: "evaluacionRiesgos",
      numeric: false,
      disablePadding: false,
      label: t('documentTypes.riskAssessment').toUpperCase(),
      noObjeto: true,
      style: { textAlign: 'center' },
      overrideFunc: (data, row) => (
        <Tooltip title={row.evaluacionRiesgosUR === '' ? t('common:suppliers.messages.lastClaim') + ': -' : t('common:suppliers.messages.lastClaim') + ": " + formatoFechasEs(row.evaluacionRiesgosUR)}>
          <img style={{ width: "20px" }} src={daysDiff(new Date(row?.evaluacionRiesgosUR), new Date()) < 60 ? Pending : !data ? Cross : Tick} alt="vacio" />
        </Tooltip>
      )
    },
    {
      id: "planificacionPreventiva",
      numeric: false,
      disablePadding: false,
      label: t('documentTypes.preventivePlanning').toUpperCase(),
      noObjeto: true,
      style: { textAlign: 'center' },
      overrideFunc: (data, row) => (
        row.noProcede ? t('common:suppliers.columns.notApplicable') :
        data ?
          <Tooltip title={row.planificacionPreventivaUR === '' ? t('common:suppliers.messages.lastClaim') + ': -' : t('common:suppliers.messages.lastClaim') + ": " + formatoFechasEs(row.planificacionPreventivaUR)}>
            <span style={{ color: daysDiff(new Date(row?.planificacionPreventivaUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
              {formatoFechasEs(data)}
            </span>
            {/* <img style={{ width: "20px" }} src={daysDiff(new Date(row.planificacionPreventivaUR), new Date()) < 60 ? Pending : !data ? Cross : Tick} alt="vacio" /> */}
          </Tooltip> : '-'

      )

    },
    {
      id: "listadoTrabajadores",
      numeric: false,
      disablePadding: false,
      label: t('documentTypes.workersList').toUpperCase(),
      noObjeto: true,
      style: { textAlign: 'center' },
      overrideFunc: (data, row) => (
        row.noProcede ? t('common:suppliers.columns.notApplicable') :
          data ?
            <Tooltip title={row?.listadoTrabajadoresUR === '' ? t('common:suppliers.messages.lastClaim') + ': -' : t('common:suppliers.messages.lastClaim') + ": " + formatoFechasEs(row?.listadoTrabajadoresUR)}>
              <span style={{ color: daysDiff(new Date(row?.listadoTrabajadoresUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
                {formatoFechasEs(data)}
              </span>
            </Tooltip> : '-'
      )
    },
    {
      id: "rlc",
      numeric: false,
      disablePadding: false,
      label: t('documentTypes.rlc').toUpperCase(),
      noObjeto: true,
      style: { whiteSpace: 'nowrap' },
      overrideFunc: (data, row) => (
        row.noProcede ? t('common:suppliers.columns.notApplicable') :
          data ?
            <Tooltip title={row?.rlcUR === '' ? t('common:suppliers.messages.lastClaim') + ': -' : t('common:suppliers.messages.lastClaim') + ": " + formatoFechasEs(row?.rlcUR)}>
              <span style={{ color: daysDiff(new Date(row?.rlcUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
                {formatoFechasEs(data)}
              </span>
            </Tooltip> : '-'
      )
    },
    {
      id: "rnt",
      numeric: false,
      disablePadding: false,
      label: t('documentTypes.rnt').toUpperCase(),
      noObjeto: true,
      style: { whiteSpace: 'nowrap' },
      overrideFunc: (data, row) => (
        row.noProcede ? t('common:suppliers.columns.notApplicable') :
          data ?
            <Tooltip title={row?.rntUR === '' ? t('common:suppliers.messages.lastClaim') + ': -' : t('common:suppliers.messages.lastClaim') + ": " + formatoFechasEs(row?.rntUR)}>
              <span style={{ color: daysDiff(new Date(row?.rntUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
                {formatoFechasEs(data)}
              </span>
            </Tooltip> : '-'
      )
    },
    {
      id: "certificado",
      numeric: false,
      disablePadding: false,
      label: t('documentTypes.socialSecurityCert'),
      noObjeto: true,
      style: { whiteSpace: 'nowrap', textAlign: 'center' },
      overrideFunc: (data, row) => (
        data ?
          <Tooltip title={row.certificadoUR === '' ? t('common:suppliers.messages.lastClaim') + ': -' : t('common:suppliers.messages.lastClaim') + ": " + formatoFechasEs(row.certificadoUR)}>
            <span style={{ color: daysDiff(new Date(row.certificadoUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
              {formatoFechasEs(data)}
            </span>
          </Tooltip> : '-'
      )
    },
    {
      id: "documentosTrabajadores",
      numeric: false,
      disablePadding: false,
      label: t('alerts.workerDocs'),
      noObjeto: true,
      style: { whiteSpace: 'nowrap', textAlign: 'center' },
      overrideFunc: (data, row) => (
        row.noProcede ? t('common:suppliers.columns.notApplicable') :
        <Tooltip title={row.docTrabajadores}>
          <img style={{ width: "20px" }} src={row.docTrabajadores ? Pending : !data ? Cross : Tick} alt="vacio" />
        </Tooltip>
      )
    },
    // {
    //   id: "vigilancia",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Vigilancia salud",
    //   noObjeto: true,
    //   overrideFunc: (data, row) => (
    //     row.noProcede ? t('common:suppliers.columns.notApplicable') :
    //       data ?
    //         <Tooltip title={row?.vigilanciaUR === '' ? t('common:suppliers.messages.lastClaim') + ': -' : "última reclamación: " + formatoFechasEs(row?.vigilanciaUR)}>
    //           <span style={{ color: daysDiff(new Date(row?.vigilanciaUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
    //             {formatoFechasEs(data)}
    //           </span>
    //         </Tooltip> : '-'
    //   )
    // },
  ];

  
  return (
    <>
      <BreadCrumb
        rutas={[{ path: "/alertas", label: t('alerts.title') }]}
        style={{ margin: "0 10px" }}
      />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">
            {t('alerts.title').toUpperCase()}
            
          </div>
          <div className="tableContainer">
            
            <div className="tableWrapper">
              <Box className="pageContent">
                <Box sx={{ mb: 10 }}>
                  <DataTable
                    data={data.rows}
                    isLoading={loading}
                    headers={proveedoresRows}
                    fetcher={fetchData}
                    meta={data.meta}
                    mensaje={t('noSuppliers')}
                  />
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
      <style jsx="true">{`
        .tableContainer table thead th {
          text-align: center;
        }
      `}</style>
    </>
  );
};

export default withRouter(Alertas);
